import { useSelector } from 'react-redux'
import * as S from './styles'

const ProdutosEsgotadosMessage = ({ message }) => {
  const store = useSelector((reduxState) => reduxState)

  const start = `produto(s)`
  const end = `esgotou`
  const middleText = message?.split(start)[1]?.split(end)[0]?.split(/ e /g)

  return (
    <S.WrapperSmall>
      {/* <div className="header">
        <h3>Problema ao converter em pedido</h3>
      </div> */}
      <p>
        Olá cliente <strong>{store.user.info.nome}</strong>,
      </p>
      <p>Infelizmente não será possível finalizar o seu pedido.</p>
      <p style={{ marginTop: 8 }}>
        O(s) produto(s) abaixo esgotou(aram) em nosso estoque. Será necessário
        fazer uma nova(cotação ou negociação).
      </p>
      <p style={{ marginTop: 8 }}>Pedimos desculpas pelo transtorno.</p>

      <ul>
        {middleText?.map((product) => {
          return <li>{product}</li>
        })}
      </ul>
    </S.WrapperSmall>
  )
}

export default ProdutosEsgotadosMessage
